var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRokobIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39.47 36.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000000;stroke-miterlimit:10;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "rokobIcon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.75,30.87c-4.06,0-8.12,0-12.18,0-.65,0-.9-.13-.9-1.08q.05-11.44,0-22.87c0-.92.22-1.11.89-1.1q12.22,0,24.44,0c.69,0,.81.29.81,1.1q0,11.44,0,22.87c0,.81-.11,1.09-.8,1.09C27.92,30.84,23.84,30.87,19.75,30.87Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "10.96 0.5 0.51 0.5 0.75 11.54"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "28.07 0.55 38.51 0.55 38.27 11.59"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "28.51 35.59 38.95 35.59 38.72 24.55"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "10.96 35.55 0.51 35.55 0.75 24.5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRokobIcon);
export default __webpack_public_path__ + "static/media/rokobIcon.e832473befcfda11c6d68639677bd74e.svg";
export { ForwardRef as ReactComponent };